// RW-1959: the shape App.js hands to every top-level surface as `user`.
// A hand-enumerated plain-object copy (not a spread of the user doc) — methods
// on the FirebaseAuth user prototype (e.g. getIdToken) are deliberately not
// exposed; call sites that need those reach for `auth.currentUser` directly.
export function buildUserWithRole(user, { role, office, officeId, ninjaMode, agentStatus, postViewer = null }) {
  if (!user) return user;
  return {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName,
    photoURL: user.photoURL,
    emailVerified: user.emailVerified,
    role,
    // Retired pair value (RW-23 analytics enrichment) — '' on most docs.
    office,
    // RW-1959: canonical office id (RW-475/RW-454). Office-based logic must
    // key on this, not `office`.
    officeId,
    ninjaMode, // RW-220
    // RW-899: lifecycle stage mirror so gated surfaces can read
    // userWithRole.agentStatus?.status === 'winding_down' (stage 1).
    agentStatus: agentStatus ? { status: agentStatus } : null,
    // RW-2957: { staff, officeId } from the users doc the posts read rule
    // reads; null until it loads. Every posts query scopes by it
    // (src/lib/postAudience.js, src/hooks/usePostScope.js).
    postViewer,
  };
}

// RW-2428: is this `user` the super-admin "Login As" stand-in (RW-187)? App.js
// substitutes the impersonated agent's doc for read-only surfaces (Feed,
// PostCard, Comments), so `user.uid` there is SOMEONE ELSE's uid. Every
// uid-keyed receipt write (postViews/…/readers/{uid}, posts/…/readBy/{uid},
// posts/…/viewers/{uid}) is owner-gated in firestore.rules — minting one under
// the agent's uid is denied by design (RW-2268), and it would inflate their
// "N of M acknowledged" count if it weren't. One predicate, so the four write
// sites cannot disagree about what impersonation looks like.
export function isImpersonatedViewer(user) {
  return !!user?._impersonated;
}
